import { createStore } from "vuex";
import persistedstate from "vuex-persistedstate";

const store = createStore({
  state() {
    return {
      tableGroupList: [],
      tableList: [],
      orderList: [],
      menuList: [],
      groupList: [],
      paymentList: [],
      descList: [],
      mstOptionList: [],
      mstItemList: [],
      baskets: [],
      salesList: [],
      receiptList: [],
      couponList: [],
      holdList: [],
      couponGroupList: [],
      couponDetailList: [],
      setMenuOptionList: [],
      setMenuItemList: [],
    };
  },
  plugins: [
    persistedstate({
      storage: window.sessionStorage,
      paths: [
        "tableGroupList",
        "tableList",
        "orderList",
        "menuList",
        "groupList",
        "paymentList",
        "descList",
        "mstOptionList",
        "mstItemList",
        "baskets",
        "salesList",
        "receiptList",
        "couponList",
        "holdList",
        "couponGroupList",
        "couponDetailList",
        "setMenuOptionList",
        "setMenuItemList",
      ],
    }),
  ],
  getters: {
    getTableGroupList(state) {
      return state.tableGroupList;
    },
    getTableList(state) {
      return state.tableList;
    },
    getOrderList(state) {
      return state.orderList;
    },
    getMenuList(state) {
      return state.menuList;
    },
    getGroupList(state) {
      return state.groupList;
    },
    getPaymentList(state) {
      return state.paymentList;
    },
    getDescList(state) {
      return state.descList;
    },
    getMstOptionList(state) {
      return state.mstOptionList;
    },
    getMstItemList(state) {
      return state.mstItemList;
    },
    getBaskets(state) {
      return state.baskets;
    },
    getSalesList(state) {
      return state.salesList;
    },
    getReceiptList(state) {
      return state.receiptList;
    },
    getCouponList(state) {
      return state.couponList;
    },
    getHoldList(state) {
      return state.holdList;
    },
    getCouponGroupList(state) {
      return state.couponGroupList;
    },
    getCouponDetailList(state) {
      return state.couponDetailList;
    },
    getSetMenuOptionList(state) {
      return state.setMenuOptionList;
    },
    getSetMenuItemList(state) {
      return state.setMenuItemList;
    },
  },
  mutations: {
    setTableGroupList(state, tableGroupList) {
      state.tableGroupList = tableGroupList;
    },
    setTableList(state, tableList) {
      state.tableList = tableList;
    },
    setOrderList(state, orderList) {
      state.orderList = orderList;
    },
    setMenuList(state, menuList) {
      state.menuList = menuList;
    },
    setGroupList(state, groupList) {
      state.groupList = groupList;
    },
    setPaymentList(state, paymentList) {
      state.paymentList = paymentList;
    },
    setDescList(state, descList) {
      state.descList = descList;
    },
    setMstOptionList(state, mstOptionList) {
      state.mstOptionList = mstOptionList;
    },
    setMstItemList(state, mstItemList) {
      state.mstItemList = mstItemList;
    },
    setBaskets(state, baskets) {
      state.baskets = baskets;
    },
    setSalesList(state, salesList) {
      state.salesList = salesList;
    },
    setReceiptList(state, receiptList) {
      state.receiptList = receiptList;
    },
    setCouponList(state, couponList) {
      state.couponList = couponList;
    },
    setHoldList(state, holdList) {
      state.holdList = holdList;
    },
    setCouponGroupList(state, couponGroupList) {
      state.couponGroupList = couponGroupList;
    },
    setCouponDetailList(state, couponDetailList) {
      state.couponDetailList = couponDetailList;
    },

    setSetMenuOptionList(state, setMenuOptionList) {
      state.setMenuOptionList = setMenuOptionList;
    },
    setSetMenuItemList(state, setMenuItemList) {
      state.setMenuItemList = setMenuItemList;
    },
  },
  actions: {
    setTableGroupList(context, tableGroupList) {
      context.commit("setTableGroupList", tableGroupList);
    },
    setTableList(context, tableList) {
      context.commit("setTableList", tableList);
    },
    setOrderList(context, orderList) {
      context.commit("setOrderList", orderList);
    },
    setMenuList(context, menuList) {
      context.commit("setMenuList", menuList);
    },
    setGroupList(context, groupList) {
      context.commit("setGroupList", groupList);
    },
    setPaymentList(context, paymentList) {
      context.commit("setPaymentList", paymentList);
    },
    setDescList(context, descList) {
      context.commit("setDescList", descList);
    },
    setMstOptionList(context, mstOptionList) {
      context.commit("setMstOptionList", mstOptionList);
    },
    setMstItemList(context, mstItemList) {
      context.commit("setMstItemList", mstItemList);
    },
    setBaskets(context, baskets) {
      context.commit("setBaskets", baskets);
    },
    setSalesList(context, salesList) {
      context.commit("setSalesList", salesList);
    },
    setReceiptList(context, receiptList) {
      context.commit("setReceiptList", receiptList);
    },
    setCouponList(context, couponList) {
      context.commit("setCouponList", couponList);
    },
    setHoldList(context, holdList) {
      context.commit("setHoldList", holdList);
    },
    setCouponGroupList(context, couponGroupList) {
      context.commit("setCouponGroupList", couponGroupList);
    },
    setCouponDetailList(context, couponDetailList) {
      context.commit("setCouponDetailList", couponDetailList);
    },

    setSetMenuOptionList(context, setMenuOptionList) {
      context.commit("setSetMenuOptionList", setMenuOptionList);
    },
    setSetMenuItemList(context, setMenuItemList) {
      context.commit("setSetMenuItemList", setMenuItemList);
    },
  },
  modules: {},
});

export default store;
